import Layout from '@/components/layout/Layout';
import ResultRequestContent from '@/components/tax-refund/result/Request/ResultRequestContent';

const ResultRequest = () => {
  return (
    <Layout>
      <ResultRequestContent />
    </Layout>
  );
};

export default ResultRequest;
